import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from "@/api/PMS/communityPartyBuilding/activityType";
import waves from "@/directive/waves"; // 水波纹指令

import add from "./add";
export default {
  components: {
    add: add
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      id: "",
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  created: function created() {
    // 获取路由的配置
    var appType = this.$route.query.appType;

    if (appType !== undefined) {
      this.listQuery.appType = parseInt(appType);
    }

    this.getList();
  },
  methods: {
    handleDeletes: function handleDeletes() {
      var ids = [];
      this.multipleSelection.forEach(function (row) {
        ids.push(row.id);
      });
      this.delete(ids);
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.id = "";
      this.title = "添加";
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(id) {
      this.id = id;
      this.title = "编辑";
      this.dialogFormVisible = true;
    },
    delete: function _delete(ids) {
      var _this2 = this;

      if (ids.length > 0) {
        this.$confirm("你确定是要删除这些活动类型吗, 是否继续?", "提示").then(function () {
          var query = {
            ids: ids,
            appType: _this2.listQuery.appType
          };
          fetchDelete(query).then(function (response) {
            if (response.data.code === 200) {
              _this2.getList();

              _this2.Alert({
                alertType: "delete"
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(id) {
      var ids = [];
      ids.push(id);
      this.delete(ids);
    }
  }
};